import TelephoneActionArea from "./telephone-action-area.vue";
import VisitActionArea from "./visit-action-area.vue";
import LegalUrgeActionArea from "./legal-urge-action-area.vue";
import { MENU_CHANNEL } from "~/config/enum.config";
/**
 * 组件
 */
export var components = {
    TelephoneActionArea: TelephoneActionArea,
    VisitActionArea: VisitActionArea,
    LegalUrgeActionArea: LegalUrgeActionArea
};
/**
 * 催收行动区业务组合
 */
export var tabs = [
    {
        name: "telephone-action-area",
        label: "电催行动区",
        channel: [
            MENU_CHANNEL.Tel_personal,
            MENU_CHANNEL.Tel_team,
            MENU_CHANNEL.Assist_tel
        ],
        // 对应历史信息业务组件设置
        historyPanel: "telephone-action-history"
    },
    {
        name: "visit-action-area",
        label: "外访行动区",
        channel: [
            MENU_CHANNEL.Visit_personal,
            MENU_CHANNEL.Visit_team,
            MENU_CHANNEL.Assist_visit
        ],
        // 对应历史信息业务组件设置
        historyPanel: "visit-action-history"
    },
    {
        name: "legal-urge-action-area",
        label: "法务行动区",
        channel: [
            MENU_CHANNEL.Legal_personal,
            MENU_CHANNEL.Legal_team,
            MENU_CHANNEL.Assist_legal
        ],
        // 对应历史信息业务组件设置
        historyPanel: "legal-urge-history"
    }
];
